"use client";

/**
 * 書庫の画面で、いまどこを見ているか（10/12 本人「書庫以外の画面へ移って戻ったら、直前の書庫の画面に戻る」）。
 * 書庫の画面が書き続け、ほかの画面から書庫へ戻ったときにここから開き直す。
 * 書庫の中で下のナビの書庫を押したときだけ消して、冒頭の画面へ戻す（BottomNav が SHELF_RESET_EVENT を出す）。
 * 置き場はメモリだけ（再読み込みで空になる）。ブラウザの保存領域を使うと、最初の描画がサーバーと食い違ってちらつくため
 */
export type ShelfMainTab = "list" | "shelf" | "vocab";
export type ShelfSubTab = "favorites" | "genre" | "cluster";

export interface ShelfView {
  mainTab: ShelfMainTab;
  /** 本棚の小さなタブ（お気に入り・ジャンル別・クラスター別） */
  subTab: ShelfSubTab | null;
  /** 開いているジャンルの棚・クラスターの棚 */
  genre: string | null;
  cluster: string | null;
  /** 開いている単語帳 */
  vocabCluster: string | null;
}

let memory: ShelfView | null = null;

export const loadShelfView = (): ShelfView | null => memory;
export const saveShelfView = (view: ShelfView) => {
  memory = view;
};
export const clearShelfView = () => {
  memory = null;
};

/** 書庫の中で下のナビの書庫を押した合図（detail.mainTab は冒頭の画面の上のタブ。下のナビで書庫の本に開く画面を決めていればそのタブ） */
export const SHELF_RESET_EVENT = "library:shelf-reset";
